<div class="slide-button">
    <div #indicator class="slide-indicator"></div>
    <div #optionRef *ngFor="let option of options" class="option" [class.active]="slideButtonService.selected() === option.value"
        (click)="slideButtonService.setSelected(option.value)" [attr.data-value]="option.value">
        <span *ngIf="option.imageUrl" class="custom-icon"
            [style.background-image]="'url(' + option.imageUrl + ')'"></span>
        <umkt-icon *ngIf="option.icon" class="icon" [icon]="option.icon"></umkt-icon>
        {{ option.label }}
    </div>
</div>